import { render } from "./IconChevronLeft.vue?vue&type=template&id=21ff081c"
import script from "./IconChevronLeft.vue?vue&type=script&lang=js"
export * from "./IconChevronLeft.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__